export const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY

export const YOUTUBE_SEARCH_API = "http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=";

export const CHAT_OFFSET = 13;

